(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["demo-request"] && !Shopify.designMode) return;
  try {
    
(function () {
  // Spam gate: drop the submit when the honeypot is filled or the form is
  // submitted faster than any human can type an email address.
  var loadedAt = Date.now();
  document.querySelectorAll('.demo-req__form').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      var hp = form.querySelector('input[name="contact[website]"]');
      if ((hp && hp.value !== '') || Date.now() - loadedAt < 2500) {
        e.preventDefault();
      }
    });
  });

  // After a successful request, take the visitor straight to the scheduler
  // to pick a slot. The button stays as the visible fallback.
  var box = document.querySelector('[data-scheduler-redirect]');
  if (!box) return;
  var url = box.getAttribute('data-scheduler-url');
  if (!url) return;
  box.scrollIntoView({ block: 'center' });
  window.setTimeout(function () { window.location.href = url; }, 1800);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scroll-rail"] && !Shopify.designMode) return;
  try {
    
(function () {
  var rail = document.querySelector('[data-scroll-rail]');
  if (!rail) return;
  var fill = rail.querySelector('[data-rail-fill]');
  var links = Array.prototype.slice.call(rail.querySelectorAll('a'));
  var targets = links.map(function (a) {
    var id = a.getAttribute('href');
    return id && id.length > 1 ? document.getElementById(id.slice(1)) : null;
  });
  var darkSections = Array.prototype.slice.call(document.querySelectorAll('.on-dark'));
  function update() {
    var y = window.scrollY + window.innerHeight * 0.36;
    var active = 0;
    targets.forEach(function (t, i) { if (t && t.offsetTop <= y) active = i; });
    var darkRects = darkSections.map(function (s) { return s.getBoundingClientRect(); });
    links.forEach(function (a, i) {
      a.classList.toggle('is-here', i === active);
      a.classList.toggle('is-done', i < active);
      // Contrast: invert this link while it visually overlaps a dark section.
      var r = a.getBoundingClientRect();
      var mid = r.top + r.height / 2;
      var overDark = darkRects.some(function (d) { return d.top <= mid && d.bottom >= mid; });
      a.classList.toggle('is-inverted', overDark);
    });
    var first = links[0].offsetTop + 6;
    fill.style.height = (links[active].offsetTop + 6 - first) + 'px';
  }
  update();
  window.addEventListener('scroll', update, { passive: true });
  window.addEventListener('resize', update);
})();

  } catch(e) { console.error(e); }
})();
})();
